export const apiUrl = "https://marinedebris.engr.uga.edu/mdtapp";
export const devAPI = process.env.GATSBY_API_URL;
export const loginUrl = process.env.GATSBY_LOGIN_URL;
